import { LoadingOutlined, WarningOutlined } from "@ant-design/icons";
import { Flex, Row, Space, Spin, Typography } from "antd";

import { useLocation } from "react-router-dom";
import Header from "./Header";

const ReNewCertError = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const typeObject = searchParams.get("type-object");

  const arrType = {
    1: "Cấp bù",
    2: "Gia hạn và cấp bù",
    3: "Điều chỉnh thông tin và cấp bù",
  };

  const nameGender = arrType[typeObject] ?? "";

  return (
    <Spin
      spinning={false}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      <Row
        justify="center"
        align="middle"
        style={{ minHeight: "60vh" }}
        className="container"
      >
        <div>
          <div className="lock-certificate-container">
            <Header />
          </div>
          <Flex justify="center" className="my-5">
            <Space direction="vertical" align="center">
              <div className="text-center "
              style={{ fontSize: "16px" }}
              >
                <div>
                  <Typography.Text type="warning ">
                    <WarningOutlined style={{ fontSize: "2.5rem" }} />
                  </Typography.Text>
                </div>
                <div>
                  Yêu cầu {nameGender} của quý khách chưa được hoàn thành.
                </div>
                <div>
                  Mọi thắc mắc liên hệ nhà cung cấp qua số{" "}
                  <Typography.Text type="danger">
                    1900.2066 – Nhánh 1{" "}
                  </Typography.Text>
                  để được hỗ trợ.
                </div>
              </div>
            </Space>
          </Flex>
        </div>
      </Row>
    </Spin>
  );
};

export default ReNewCertError;
